import { ScratchCampaign } from './types'
import { clone } from '@/utils/helpers/';

export function initScratchCampaign(): ScratchCampaign {
  return {};
};
